import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import RegModal from '../../../supply/Supply/screens/RegistrationModal';
import '../../../../styles/login-register/login-register.scss';
import formSchema from './formSchema';

class RegistrationModal extends Component {
  render() {
    const { acctok, registrationData } = this.props;
    return (
      <Grid container className="template-entry" justify={'space-between'}>
        <Grid
          item
          xs={12}
          className={'registration-background b-entry-background'}
        >
          <RegModal
            open={true}
            acctok={acctok}
            registrationData={registrationData}
            formSchema={formSchema}
          />
        </Grid>
      </Grid>
    );
  }
}

export default RegistrationModal;
